import { Task } from '../types';

const KNOWN_PROJECTS = ['Newbury', 'First Choice/Juniper', 'Busboom', 'Conifer', 'Internal'];

interface Props {
  tasks: Task[];
  active: string | null;
  onChange: (project: string | null) => void;
}

export function ProjectFilter({ tasks, active, onChange }: Props) {
  // Count active (non-completed) tasks per project
  const counts = new Map<string, number>();
  let totalActive = 0;
  for (const task of tasks) {
    if (task.status === 'completed') continue;
    totalActive++;
    if (task.project) {
      counts.set(task.project, (counts.get(task.project) ?? 0) + 1);
    }
  }

  // Combine hardcoded list with any dynamically discovered projects
  const extraProjects = [...counts.keys()].filter((p) => !KNOWN_PROJECTS.includes(p));
  const allProjects = [...KNOWN_PROJECTS, ...extraProjects];

  return (
    <div className="flex items-center gap-1.5 px-6 py-2 border-b border-gray-800/50 flex-wrap shrink-0">
      <span className="text-xs text-gray-600 font-medium mr-1">Project:</span>

      <button
        onClick={() => onChange(null)}
        className={`text-xs px-2.5 py-1 rounded-full border transition flex items-center gap-1.5 ${
          active === null
            ? 'bg-indigo-600 border-indigo-600 text-white'
            : 'border-gray-700 text-gray-400 hover:border-gray-500 hover:text-gray-300'
        }`}
      >
        All
        {totalActive > 0 && (
          <span className={`text-[10px] rounded-full px-1.5 py-0 font-medium ${
            active === null ? 'bg-indigo-500 text-white' : 'bg-gray-800 text-gray-500'
          }`}>
            {totalActive}
          </span>
        )}
      </button>

      {allProjects.map((p) => {
        const count = counts.get(p) ?? 0;
        return (
          <button
            key={p}
            onClick={() => onChange(active === p ? null : p)}
            className={`text-xs px-2.5 py-1 rounded-full border transition flex items-center gap-1.5 ${
              active === p
                ? 'bg-indigo-600 border-indigo-600 text-white'
                : count > 0
                ? 'border-gray-700 text-gray-400 hover:border-gray-500 hover:text-gray-300'
                : 'border-gray-800 text-gray-600 hover:border-gray-700 hover:text-gray-500'
            }`}
          >
            {p}
            {count > 0 && (
              <span className={`text-[10px] rounded-full px-1.5 py-0 font-medium ${
                active === p ? 'bg-indigo-500 text-white' : 'bg-gray-800 text-gray-500'
              }`}>
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
